var React = require('react');

function ClockCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#323643","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("path",{"d":"M8 4v4l2.65 2.58","key":0}),React.createElement("path",{"d":"M14.373 9.964c-.133.43-.308.843-.52 1.231m-1.257 1.633c-.316.3-.661.571-1.032.806m-1.71.77c-.59.171-1.215.263-1.862.263-3.68 0-6.659-2.99-6.659-6.667 0-3.677 2.979-6.667 6.659-6.667A6.668 6.668 0 0 1 14.667 8","key":1})]));
}

ClockCircle.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ClockCircle;

ClockCircle.default = ClockCircle;
